<template>
  <div :class="dark?'contentBox darkBox':'contentBox'" style="padding-bottom:1rem;padding-top：3rem;display:flex;flex-direction:column;justify-content:center;align-items:space-around">
    <v-row align="center" justify="center">
       <h1 v-show='data.content.title' :class="dark?'text-justify font-weight-thin mb-4 third_title white--text':'text-justify font-weight-thin mb-4 third_title'">{{data.content.title}}</h1>
    </v-row>
    <v-row  class="fill-height" align="center" justify="space-around">
      <v-card
        :color="background?background:'rgba(212, 217, 223, 0)'"
        class="ma-4"
        :height='card_height'
        :width='card_width'
        min-width="150"
        elevation=0
        v-for='li in data.content.list' :key='li.index'
      >
        <v-col justify="center" align="center">
          <img :src='require("../assets/images/"+ li.src)' v-show="img_top" :style="{ width: img_size }">
          <v-row justify="center" align="center">
            <v-card-title :class="dark?'body_text white--text':'body_text'" v-html='li.title'></v-card-title>
          </v-row>
          <p :class="dark?'card_text white--text':'card_text'" style="text-align:center;margin:auto" v-html='li.subtitle'>
          </p>
          <p :class="dark?'card_text white--text':'card_text'" style="text-align:center;margin:auto" v-html='li.body'>
          </p>
          <div style="width:calc(100% - 32px);position:absolute;bottom:1rem;margin:auto" v-show="!img_top">
            <img :src='require("../assets/images/"+ li.src)' :style="{ width: img_size }">
          </div>
        </v-col>
      </v-card>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'box-center',

  props: {
    dark: Boolean,
    card_height: String,
    card_width: String,
    img_size: String,
    img_top: Boolean,
    data: Object,
    background: String
  },
  created () {
  },
  data: () => ({
    img_pre: "require('../assets/images/",
    backgroundcolor: 'var(--iconColor)'
  })
}
</script>

<style>

</style>
